<template>
	<div class="fz-12 yx-color-text-primary">
		{{ row.shopClaimUserName | formatEmpty }}
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	components: {},
	computed: {},
	data() {
		return {};
	},
	methods: {},
};
</script>
<style lang="less" scoped></style>